import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { LoadingController, Platform } from "ionic-angular";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
// import { RequestReportSendEmailExcelDto } from "../../shared/nestjs/gd-only/dto/survey-service.dto";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { LoopBackAuth } from "../../shared/sdk";
import { RequestPerformanceRecordDto, RequestPerformanceSearchDto, RequestPerformanceRecordEmailDto } from "../../shared/nestjs/gd-only/dto/performance-report.dto";
import { PerformanceReportApi } from "../../shared/nestjs/gd-only/services/performance-report.api";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";

@Injectable()
export class PerformanceReportBloc {
  isGoPathNew: Boolean;
  loading: any;
  requestBodyPerformance: RequestPerformanceRecordDto = new RequestPerformanceRecordDto();
  // requestSendEmail: RequestReportSendEmailExcelDto = new RequestReportSendEmailExcelDto();

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private nestApiProvider: NestApiProvider,
    private platform: Platform,
    private fileDownloaderProvider: FileDownloaderProvider,
    private loadingCtrl: LoadingController,
    private performanceReportApi: PerformanceReportApi,
    public analyticsProvider: AnalyticsProvider,
  ) {
  }

  getPeriodLists(data: RequestPerformanceSearchDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let getPeriod = this.performanceReportApi.getPeriodList(data).subscribe(result => {
        resolve({ status: true, data: result })
      }, error => {
        reject({ status: true })
      }, () => {
        getPeriod.unsubscribe()
      })
    })
  }


  async downloadExcel(dataRequest: RequestPerformanceRecordDto) {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    if (this.isGoPathNew) {
      this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
      return await this.generateExcel(dataRequest)
    }

  }

  generateExcel(data: RequestPerformanceRecordDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let downloadExcel = this.performanceReportApi.downloadExcel(data).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadExcelBlob(result, 'Performance Report')
          resolve('Download successfully');
        } else {
          saveAs(result, 'Performance Report.xlsx')
          resolve('Download successfully');
        }
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
        this.loading.dismiss();
      })

    })
  }


  async downloadPDF(dataRequest: RequestPerformanceRecordDto) {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    if (this.isGoPathNew) {
      this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
      return await this.generatePdf(dataRequest)
    }
  }

  private generatePdf(data: RequestPerformanceRecordDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let downloadExcel = this.performanceReportApi.downloadPdf(data).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadPdfBlob(result, 'Performance Report')
          resolve('Download successfully');
        } else {
          saveAs(result, 'Performance Report.pdf')
          resolve('Download successfully');
        }
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
        this.loading.dismiss();
      })

    })
  }

  async sendMailExcel(data: RequestPerformanceRecordEmailDto) {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
    return await this.sendEmailExcel(data)

    // this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    // if (this.isGoPathNew) {
    //   this.requestSendEmail.code = data.periodId;
    //   this.requestSendEmail.emailTo = data.email;
    //   this.requestSendEmail.fullName = data.fullName;
    //   return await this.sendEmailExcel(data)
    // } else {
    //   return await this.sendEmailExcelLB(data);
    // }
  }

  async sendMailPdf(data: RequestPerformanceRecordEmailDto) {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
    return await this.sendEmailPdf(data)
    // this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    // if (this.isGoPathNew) {
    //   this.requestSendEmail.code = data.code;
    //   this.requestSendEmail.emailTo = data.emailTo;
    //   this.requestSendEmail.fullName = data.fullName;
    //   return await this.sendEmailPdf(data)
    // } else {
    //   return await this.sendEmailPdfLB(data);
    // }
  }

  private async sendEmailPdf(data: RequestPerformanceRecordEmailDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let sendEmailPdf = this.performanceReportApi.reportSendEmailPdf(data).subscribe(result => {
        resolve("Send Email Successfully")
      }, error => {
        reject(error.message);
        console.log('error', error);
      }, () => {
        sendEmailPdf.unsubscribe();
      })
    })
  }

  private async sendEmailExcel(data: RequestPerformanceRecordEmailDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let sendEmailExcel = this.performanceReportApi.reportSendEmailExcel(data).subscribe(result => {
        resolve("Send Email Successfully");
      }, error => {
        reject(error.message);
      }, () => {
        this.loading.dismiss();
        sendEmailExcel.unsubscribe();
      })
    })
  }

  loader(): void {
    this.loading = this.loadingCtrl.create();
    this.loading.present();
  }

}



// WEBPACK FOOTER //
// ./src/bloc/report/performance-report.bloc.ts